import { datahubIntegrationApiSlice } from "../apiSlice";

export const datahubApiSlice = datahubIntegrationApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDatahubAccountById: builder.query({
      query: (recalc_account_id) => `/account?recalc_account_id=${recalc_account_id}`,
      providesTags: ['DatahubIntegrationAccount'],
      transformResponse: (response) => Array.isArray(response) ? response : [response]
    }),
    postDatahubIntegrationAccount: builder.mutation({
      query: args => ({
        url: `/account?guard_flag=true`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: args
      }),
      invalidatesTags: ['DatahubIntegrationAccount']
    }),
    postDatahubIntegrationAccountRetry: builder.mutation({
      query: ({recalc_account_id, cvr_number}) => ({
          url: `/account/${recalc_account_id}/${cvr_number}?guard_flag=true`,
          method: 'PATCH',
      }),
      invalidatesTags: (result, error) => error ? [] : ['DatahubIntegrationAccount'],
  })
  }),

});

export const { useGetDatahubAccountByIdQuery, usePostDatahubIntegrationAccountMutation, usePostDatahubIntegrationAccountRetryMutation } = datahubApiSlice;